module.exports = __webpack_public_path__ + "media/images/site-section/header-background-desk-b79e7d3bb791a7674e7ac33fd8de2459.jpg";